<i18n src="@/locales/modules/AlarmTranslate.json"></i18n>

<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="w-full flex justify-between mr-4">
				<div>
					<h4 class="uppercase font-bold block text-xl w-full">{{ $t("DetailAlarm") }}</h4>
					<p class="text-base text-black font-medium">{{ localData.title }}</p>
				</div>
			</div>
			<div class="p-6">
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("Object") }}:</label>
					</vs-col>

					<vs-col vs-w="8" vs-xs="6" class="text-black">
						<display-relations class="flex flex-col" :relations="relations" />
					</vs-col>
				</vs-row>
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("ReminingTimes") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black">{{ localData.created_at | dateTime(userDateTimeFormat) }}</vs-col>
				</vs-row>
				<!-- Description -->
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("Description") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black" v-html="localData.desc"></vs-col>
				</vs-row>
				<vs-row class="mb-2">
					<vs-col vs-w="4" vs-xs="6">
						<label for>{{ $t("Tutorial") }}:</label>
					</vs-col>
					<vs-col vs-w="8" vs-xs="6" class="text-black" v-html="localData.tutorial"></vs-col>
				</vs-row>
			</div>
			<div class="flex justify-center flex-wrap items-center" slot="footer">
				<vs-button v-if="!localData.is_received" class="w-full sm:w-1/3 font-bold" @click.stop="received()">{{ $t("GetTask") }}</vs-button>
				<div v-else class="flex items-center">
					<i class="nucleo nucleo-cmchecksingle font-medium text-solid-green-2 mr-3 text-xl"></i>
					<p class="text-solid-green-2 text-lg font-medium">{{ $t("Received") }}</p>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import DisplayRelations from "@/components/display-relations/DisplayRelations.vue";

export default {
	name: "AlarmDetailDialog",
	components: { DisplayRelations },

	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showLogsCurrentTodo: true,
			showLogsDoneTodo: true
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar", val);
				}
			}
		},

		localData() {
			return this.data ? this.data : {};
		},
		relations() {
			const idx = this.localData.ref_type.lastIndexOf("\\");
			const type = this.localData.ref_type.slice(idx + 1, this.localData.ref_type.length);
			return [{ ...this.localData.ref, type: type }];
		}
	},
	methods: {
		received() {
			this.$emit("onClickReceived", this.data);
		}
	}
};
</script>

<style></style>
